import { CSSProperties, ReactNode } from 'react';
import {
  ListItem as MUIListItem,
  ListItemProps as MUIListItemProps,
} from '@mui/material';

type AtomMUIProps = {
  children?: ReactNode;
  style?: CSSProperties;
  disableGutters?: boolean;
  disablePadding?: boolean;
  secondaryAction?: ReactNode;
  onClick?: () => void;
};

export type ListItemProps = AtomMUIProps;

export const ListItem = (props: ListItemProps) => {
  const { style = {}, ...data } = props;

  const MUIProps: MUIListItemProps = data;

  return (
    <MUIListItem
      {...MUIProps}
      style={style}
      sx={{ paddingTop: '8px', paddingBottom: '8px' }}
    />
  );
};

export default ListItem;
